<template>
    <div>
        <b-modal
            centered
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
            v-model="confirmCancel.show"
            @hidden="closeModalConfirmCancel()"
        >
            <template slot="modal-title">
                <div slot="header" class="bg-white border-0">
                    <div class="row align-items-center">
                        <div class="col-12 text-center">
                            <h3 class="mb-0">คำขอยกเลิกรายการพัสดุ {{confirmCancel.number}} รายการ</h3>
                        </div>
                    </div>
                </div>
            </template>
            <card shadow type="secondary" class="m--4">
                <div class="row">
                    <div class="col-lg-12">
                        <label>เหตุผลในการยกเลิก :</label>
                        <textarea
                            rows="3"
                            class="form-control"
                            placeholder="กรุณาระบุเหตุผลในการยกเลิก"
                            v-model="confirmCancel.remark"
                        ></textarea>
                        <small class="text-muted">การขอยกเลิกจะใช้เวลาในการดำเนินการภายใน 1-2 วันทำการ กรณีที่สถานะการขอยกเลิกยังไม่สำเร็จ 
                            หากนำพัสดุไปส่ง เราจะคิดค่าบริการตามปกติ คุณสามารถเช็คสถานะการยกเลิกได้ที่หน้า 
                            <router-link tag="a" to="/historycancel">ประวัติยกเลิกรายการ</router-link>
                        </small>
                        <div class="w-100 text-right pt-4">
                            <b-button variant="secondary" @click="closeModalConfirmCancel()">ปิด</b-button>
                            <b-button variant="success" 
                                @click="comfirm()">
                                ยืนยัน
                            </b-button>
                        </div>
                    </div>
                </div>
            </card>
            
        </b-modal>
    </div>
</template>
<script>
export default {
    name: "ModalConfirmCancel" ,
    props: {
        confirmCancel: Object,
    },
    data(){
        return{
         
        }
    },
    mounted() {

    }, 
    methods: {
        async comfirm(){
            await this.confirmCancel.funcRemoveItem()
            this.closeModalConfirmCancel()
        },
        closeModalConfirmCancel(){
            this.confirmCancel.show = false
            this.confirmCancel.remark = ''
        },
    }
}
</script>
